/**
 * testGroupApi.js
 * ---------------
 * Live backend client API for Test Groups / Series.
 * Fully compliant with Rule 90 (Zero Mock Data).
 */
import api from '../../../../api/client'

export async function listTestGroups(params = {}) {
  const { data } = await api.get('/education/tests/groups', { params })
  return Array.isArray(data) ? data : data?.items || []
}

export async function getTestGroupDetail(id) {
  const { data } = await api.get(`/education/tests/groups/${id}`)
  return data
}

export async function createTestGroup(payload) {
  const { data } = await api.post('/education/tests/groups', payload)
  return data
}

export async function updateTestGroup(id, payload) {
  const { data } = await api.put(`/education/tests/groups/${id}`, payload)
  return data
}

export async function deleteTestGroup(id) {
  const { data } = await api.delete(`/education/tests/groups/${id}`)
  return data
}
